import { render, staticRenderFns } from "./kota.vue?vue&type=template&id=56671032"
import script from "./kota.vue?vue&type=script&lang=js"
export * from "./kota.vue?vue&type=script&lang=js"
import style0 from "./kota.vue?vue&type=style&index=0&id=56671032&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports